module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAICAYAAADwdn+XAAAAAXNSR0IArs4c6QAAAPhJREFUKBVjYMAB/v//z/jJyKj7k4FBF4iNQxkDVon/Dg4snz98mM3AyKgB1vj//w1eAYFUxgMH/qAbhGHAf0tLzs8/fqwEKmTlFRUNAWn4/Pr1GiD1m5eDI5zx+PHvIDEYYIIxQDTQZoEv37/vApr6mZeJyY9x166vIAxmA8VAciA1yHrgLvhqbCz579+/nUDJ/TznzhUwMjL+R1YICocvRkYTgGKOTExM7txnzz6Hy/8wMlIBBta9z0ZG1XBBHAyQGpBakB6QEkagzUZAm7cAA6yB99y5WTj0oQgDDUlj+P+/AegSH4bPBgbngQJBKCqI4ID0gPQCADvkY7ew99fbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/withdraw@2x.png
// module id = tXS0
// module chunks = 2